import { Component, forwardRef, Inject } from '@angular/core';
import { DialogPopupComponent } from "./dialog-popup.component";
import { Button } from './button.model';

@Component({
    selector: 'dialog-popup-body',
    templateUrl: './dialog-popup-body.component.html',
    styleUrls: ['./dialog-popup-body.component.less']
})
export class DialogPopupBodyComponent {

    btnDisabled: boolean = false;

    constructor(

        @Inject(forwardRef(() => DialogPopupComponent)) public parent: DialogPopupComponent

    ) {
    }

    handleButtonClick(item: Button): void {
        if (item && item.clickHandler) {
            // Disable buttons
            if (this.parent.getDisableButtonsAfterAction())
                this.btnDisabled = true;

            item.clickHandler();
        }
    }
}
